<template>
    <section class="login">
      <div v-if="!login">
        <label for="loginName">Enter login name</label>
        <input type="text" name="loginName" id="loginName" v-model="loginName">
        <button @click="getLogin">Login</button>
      </div>
      <div v-else>
        <h1>Bienvenido {{loginName}}</h1>
        <button @click="getLogout">Logout</button>
        <ListClients></ListClients>
        <LinkTo></LinkTo>
        <Monit></Monit>
      </div>
    </section>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import ListClients from "./ListClients.vue";
import LinkTo from "./LinkTo.vue";
import Monit from "./Monit.vue";

export default {
  name: "Login",
  data() {
    return {
      loginName: null
    };
  },
  computed: {
    ...mapState(["login", "admin"])
  },
  methods: {
    ...mapMutations(["updateLogin", "updateAdmin"]),
    getLogin() {
      this.$socket.emit("reqLogin", this.loginName);
    },
    getLogout() {
      this.updateLogin(false);
      this.$socket.emit("reqRemoveAdmin", this.admin);
    }
  },
  sockets: {
    resLogin(data) {
      this.updateLogin(data);
      this.updateAdmin(this.loginName);
    }
  },
  components: {
    ListClients,
    LinkTo,
    Monit
  }
};
</script>

<style lang="scss">
</style>
